import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AttractionsIcon from '@mui/icons-material/Attractions';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import BusinessIcon from '@mui/icons-material/Business';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import DirectionsSubwayIcon from '@mui/icons-material/DirectionsSubway';
import FlagIcon from '@mui/icons-material/Flag';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import HotelIcon from '@mui/icons-material/Hotel';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import MapIcon from '@mui/icons-material/Map';
import PlaceIcon from '@mui/icons-material/Place';
import PublicIcon from '@mui/icons-material/Public';
import SchoolIcon from '@mui/icons-material/School';
import StorefrontIcon from '@mui/icons-material/Storefront';
import TrainIcon from '@mui/icons-material/Train';
import { hotelLocationTypeColor, hotelLocationTypeLabel } from '../../../utils/hotelLocationType';

const HOTEL_LOCATION_TYPE_ICONS = {
  AIRPORT: FlightTakeoffIcon,
  RAILWAY_STATION: TrainIcon,
  METRO_STATION: DirectionsSubwayIcon,
  BUS_TERMINAL: DirectionsBusIcon,
  HOSPITAL: LocalHospitalIcon,
  MALL: LocalMallIcon,
  BEACH: BeachAccessIcon,
  TOURIST_ATTRACTION: AttractionsIcon,
  RELIGIOUS_PLACE: AccountBalanceIcon,
  MARKET: StorefrontIcon,
  AREA: MapIcon,
  LANDMARK: FlagIcon,
  BUSINESS_DISTRICT: BusinessIcon,
  UNIVERSITY: SchoolIcon,
  CITY: LocationCityIcon,
  HOTEL: HotelIcon,
  COUNTRY: PublicIcon,
  REGION: PublicIcon,
  LOCATION: PlaceIcon,
};

class HotelLocationTypeIcon extends React.Component {
  render() {
    const type = String(this.props.locationType || '').trim();
    const label = hotelLocationTypeLabel(type);
    const Icon = HOTEL_LOCATION_TYPE_ICONS[type] || PlaceIcon;

    return (
      <Tooltip title={label} placement="top" enterDelay={200}>
        <span className="hotel-location-type-icon" aria-label={label}>
          <Icon sx={{ fontSize: 16, color: hotelLocationTypeColor(type) }} />
        </span>
      </Tooltip>
    );
  }
}

export default HotelLocationTypeIcon;
